import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { UserGroupSubscriptionMaintenanceService } from 'src/app/features/system-setting/service/user-group-subscription-maintenance.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-tenant-mapping-user-group-detail-dialog',
  templateUrl: './tenant-mapping-user-group-detail-dialog.component.html',
  styleUrls: ['./tenant-mapping-user-group-detail-dialog.component.scss'],
})
export class TenantMappingUserGroupDetailDialogComponent extends SessionBaseComponent implements OnInit {

  @Input() tenantMappingUserGroupSeqNo: any;
  @Output() visibleChange = new EventEmitter<any>();

  isVisible: boolean = false;
  tenantMappingUserGroupDetailData: any[] = [];
  tenantMappingUserGroupDetailColumns: any[] = [];
  isLoading: boolean = false;

  readonly preferenceKey: string = UserPreferenceConstants.TenantMappingUserGroupDetailTableData;

  @ViewChild('table') table!: DataTableComponent;

  constructor(
    injector: Injector,
    private userGroupSubscriptionMaintenanceService: UserGroupSubscriptionMaintenanceService,
  ) {
    super(injector);

    this.tenantMappingUserGroupDetailColumns = this.tenantMappingUserGroupDetailTableTranslation();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
    if (!value) {
      this.tenantMappingUserGroupDetailData = [];
    }
  }

  onHide(value: boolean): void {
    this.visibleChange.emit(value);
  }

  getTenantMappingUserGroupDetail(tenantMappingUserGroupSeqNo: any): void {
    this.isLoading = true;
    this.userGroupSubscriptionMaintenanceService.getTenantMappingUserGroupDetail(tenantMappingUserGroupSeqNo).subscribe({
      next: (result: any) => {
        this.tenantMappingUserGroupDetailData = result;
        this.isLoading = false;
      }
    });
  }

  tenantMappingUserGroupDetailTableTranslation(): any[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];

    fields = ['email'];
    jsons = [
      'UserGroupSubscriptionMaintenance.TenantMappingUserGrouupDetailDialog.Table.Columns.Email',
    ];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i]).subscribe((translation: string) => {
        tmpcolumn[i] = ({ field: fields[i], header: translation, sort: false });
      });
    }
    return tmpcolumn;
  }
}
